import React from 'react';
import { useTranslation } from 'react-i18next';
import PackageStructureTierRow from './PackageStructureTierRowBeta';

const PackageStructurePackageRow = ({ package: pkg, isExpanded, onToggle, expandedTiers, onToggleTier }) => {
    const { t } = useTranslation();

    const tierCount = pkg.tiers.length;
    const tierLabel = tierCount === 1 ? t('priceSimulation.tierSingular') : t('priceSimulation.tiers');

    return (
        <div className="simulation-package-row">
            <div className="simulation-package-header" onClick={onToggle}>
                <div className="package-header-left">
                    <span className="vismaicon vismaicon-sm vismaicon-box"></span>
                    <span className="package-name">{pkg.name}</span>
                </div>
                <div className="package-header-right">
                    <span className="tier-count">
                        {tierCount} {tierLabel}
                    </span>
                    <span className={`expand-chevron ${isExpanded ? 'expanded' : ''}`}>
                        <span className="caret caret-lg"></span>
                    </span>
                </div>
            </div>
            {isExpanded && (
                <div className="simulation-package-content">
                    {pkg.tiers.map((tier) => (
                        <PackageStructureTierRow key={tier.id} tier={tier} isExpanded={expandedTiers[tier.id] || false} onToggle={() => onToggleTier(tier.id)} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default PackageStructurePackageRow;
